import script from "./Leads.vue?vue&type=script&setup=true&lang=js"
export * from "./Leads.vue?vue&type=script&setup=true&lang=js"

import "./Leads.vue?vue&type=style&index=0&id=14af4615&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14af4615"]])

export default __exports__